import React, {FC, Fragment} from "react";
import {Box, Fab, makeStyles} from "@material-ui/core";
import {px} from "Configs/theme";
import AuthSignOutModal from "Components/Auth/AuthSignOutModal";
import {useModalController} from "Components/Modal/Modal";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {useApp} from "Providers/AppProvider";

interface Props {
  fab?: JSX.Element;
}

const SidebarView: FC<Props> = (props) => {
  const classes = useStyles();
  const { isStandaloneApp } = useApp();
  const authSignOutMc = useModalController();

  return (
    <Fragment>
      <Box className={classes.root}>
        <Box className={classes.scroll}>{props.children}</Box>
        {isStandaloneApp && (
          <Fab
            className={classes.signOutFab}
            color="secondary"
            onClick={authSignOutMc.open}
          >
            <ExitToAppIcon />
          </Fab>
        )}
        {props.fab}
      </Box>
      {isStandaloneApp && <AuthSignOutModal modalController={authSignOutMc} />}
    </Fragment>
  );
};

export default SidebarView;

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: 355,
  },
  scroll: {
    display: "flex",
    position: "absolute",
    overflow: "auto",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: px.m,
  },
  signOutFab: {
    position: "absolute",
    bottom: px.l,
    left: px.l,
  },
});
